// extracted by mini-css-extract-plugin
export default {"wrapper":"Account_wrapper__s34GI"};